import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";

/**
 * Short legal disclaimer shown after AI-generated advice (diagnosis, fertilizer).
 * Variant: "short" (inline), "full" (in About page).
 */
export default function DisclaimerBanner({ variant = "short" }) {
  const { t } = useTranslation();

  if (variant === "full") {
    return (
      <section className="vs-card p-5 vs-fade-up" data-testid="disclaimer-full"
        style={{ borderLeft: "6px solid var(--accent)" }}>
        <div className="flex items-center gap-2 mb-3">
          <ShieldAlert size={22} style={{ color: "var(--accent)" }} />
          <h3 className="heading text-lg font-bold">{t("disclaimerBanner.fullTitle")}</h3>
        </div>
        <div className="text-sm space-y-3" style={{ color: "var(--text-secondary)", lineHeight: 1.6 }}>
          <p>
            <strong>{t("disclaimerBanner.fullPara1Bold")}</strong>{" "}
            {t("disclaimerBanner.fullPara1Suffix")}{" "}
            <strong>{t("disclaimerBanner.fullPara1Bold2")}</strong>{" "}
            {t("disclaimerBanner.fullPara1Suffix2")}
          </p>
          <p>
            <strong>{t("disclaimerBanner.fullPara2Bold")}</strong>{" "}
            {t("disclaimerBanner.fullPara2Suffix")}
          </p>
          <p>
            {t("disclaimerBanner.fullPara3Prefix")}{" "}
            <strong>{t("disclaimerBanner.fullPara3Bold")}</strong>{" "}
            {t("disclaimerBanner.fullPara3Suffix")}
          </p>
          <p>
            {t("disclaimerBanner.fullPara4Prefix")}{" "}
            <strong>{t("disclaimerBanner.fullPara4Bold")}</strong>{" "}
            {t("disclaimerBanner.fullPara4Suffix")}
          </p>
          <p className="text-xs italic pt-3"
            style={{ color: "var(--text-muted)", borderTop: "1px dashed var(--border)" }}>
            {t("disclaimerBanner.fullFooter")}
          </p>
        </div>
      </section>
    );
  }

  // Short inline version
  return (
    <div className="mt-3 pt-3 p-3 rounded-lg flex items-start gap-2"
      style={{ background: "#FFF8E6", border: "1.5px solid #D9A441" }}
      data-testid="disclaimer-short">
      <ShieldAlert size={16} style={{ color: "#7A5300", marginTop: 1, flexShrink: 0 }} />
      <p className="text-xs" style={{ color: "#5A3D00", lineHeight: 1.5 }}>
        <strong>{t("disclaimerBanner.shortBold")}</strong> {t("disclaimerBanner.shortSuffix")}
      </p>
    </div>
  );
}
